import { appendALExamTemplate } from '@/functions/idp'
import RIC from './RIC_2'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
